import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

export function FinalCta() {
  return (
    <section className="bg-slate-900 py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Mulai Usaha dengan Hitungan yang Lebih Jelas
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Jangan hanya mengandalkan perkiraan. Gunakan KalkuBisnis untuk membantu memahami
            biaya, harga jual, titik impas, dan pencatatan penjualan usahamu.
          </p>
          <div className="mt-8">
            <CtaButton testid="final-cta-button" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
